import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';

const TooltipPortal = ({ children, targetRef }) => {
  const [position, setPosition] = useState(null);

  useEffect(() => {
    const updatePosition = () => {
      if (targetRef.current) {
        const rect = targetRef.current.getBoundingClientRect();
        const windowHeight = window.innerHeight;
        const tooltipHeight = 400; // משוער
        
        // בדיקה אם יש מקום למטה
        const spaceBelow = windowHeight - rect.bottom;
        const shouldOpenUp = spaceBelow < tooltipHeight;
        
        if (shouldOpenUp) {
          // פתח למעלה
          setPosition({
            top: rect.top + window.scrollY - 10,
            left: rect.left + window.scrollX + (rect.width / 2),
            direction: 'up'
          });
        } else {
          // פתח למטה (ברירת מחדל)
          setPosition({
            top: rect.bottom + window.scrollY + 10,
            left: rect.left + window.scrollX + (rect.width / 2),
            direction: 'down'
          });
        }
      }
    };

    updatePosition();
    window.addEventListener('scroll', updatePosition);
    window.addEventListener('resize', updatePosition);

    return () => {
      window.removeEventListener('scroll', updatePosition);
      window.removeEventListener('resize', updatePosition);
    };
  }, [targetRef]);

  if (!position) return null;

  const transformClass = position.direction === 'up' 
    ? 'transform -translate-x-1/2 -translate-y-full'
    : 'transform -translate-x-1/2';

  return ReactDOM.createPortal(
    <div
      className={`z-[9999] absolute ${transformClass}`}
      style={{ 
        top: position.top, 
        left: position.left,
      }}
    >
      <div className="animate-in fade-in slide-in-from-bottom-4 zoom-in-95 duration-300 ease-out">
        <div className="bg-gray-900 text-white p-4 rounded-xl shadow-2xl max-w-xs md:max-w-md border border-gray-600 text-sm leading-relaxed">
          {children}
          
          {/* חץ שמתאים לכיוון */}
          <div className={`absolute ${position.direction === 'up' ? 'bottom-full left-1/2' : 'top-full left-1/2'} transform -translate-x-1/2`}>
            <div className={`w-0 h-0 ${
              position.direction === 'up' 
                ? 'border-l-4 border-r-4 border-b-4 border-transparent border-b-gray-900'
                : 'border-l-4 border-r-4 border-t-4 border-transparent border-t-gray-900'
            }`}></div>
          </div>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default TooltipPortal;